import React from 'react';

/**
 * Card and wallet marks drawn inline so the checkout row always renders crisp,
 * with no external requests and no broken images.
 */
const tile = 'flex h-8 w-[52px] items-center justify-center rounded-[3px] bg-white';
export function PaymentLogos() {
  return <ul className="flex flex-wrap items-center gap-2" aria-label="Accepted payment methods" data-id="element-1007" data-mp="7fusdjmo1x7r">
      <li className={tile} title="Visa" data-id="element-1008" data-mp="2h9p1bc4axf3">
        <svg viewBox="0 0 48 16" className="h-3 w-[38px]" role="img" aria-label="Visa" data-id="element-1009" data-mp="3atxh8d5n9b1h">
          <text x="0" y="13" fill="#1A1F71" fontFamily="Arial, Helvetica, sans-serif" fontSize="15" fontStyle="italic" fontWeight="700" letterSpacing="0.5" data-id="element-1010" data-mp="35w5lt95sj6sj">
            VISA
          </text>
        </svg>
      </li>

      <li className={tile} title="Mastercard" data-id="element-1011" data-mp="101cpq3aivqr6">
        <svg viewBox="0 0 40 24" className="h-5 w-[34px]" role="img" aria-label="Mastercard" data-id="element-1012" data-mp="104icvczlcik9">
          <circle cx="15" cy="12" r="9" fill="#EB001B" data-id="element-1013" data-mp="v5xc9cgffwva" />
          <circle cx="25" cy="12" r="9" fill="#F79E1B" data-id="element-1014" data-mp="3v2vawhciayy8" />
          <path d="M20 4.6a9 9 0 000 14.8A9 9 0 0020 4.6z" fill="#FF5F00" data-id="element-1015" data-mp="3x3ont1uo6gp" />
        </svg>
      </li>

      <li className={tile} title="American Express" data-id="element-1016" data-mp="8wq2a3llboq1">
        <svg viewBox="0 0 52 16" className="h-4 w-[46px]" role="img" aria-label="American Express" data-id="element-1017" data-mp="8wyerudsws0p">
          <rect width="52" height="16" rx="2" fill="#2E77BC" data-id="element-1018" data-mp="cxie94luk7q0" />
          <text x="26" y="11.5" textAnchor="middle" fill="#FFFFFF" fontFamily="Arial, Helvetica, sans-serif" fontSize="8" fontWeight="700" letterSpacing="0.4" data-id="element-1019" data-mp="3cdyhefoxoah2">
            AMEX
          </text>
        </svg>
      </li>

      <li className={tile} title="Discover" data-id="element-1020" data-mp="3q5da5e8n7q1b">
        <svg viewBox="0 0 52 16" className="h-4 w-[46px]" role="img" aria-label="Discover" data-id="element-1021" data-mp="2tmns22yuw5ra">
          <text x="0" y="12" fill="#231F20" fontFamily="Arial, Helvetica, sans-serif" fontSize="9" fontWeight="700" data-id="element-1022" data-mp="2xo9dicpghsd3">
            DISC
          </text>
          <circle cx="44" cy="8" r="6" fill="#F26E21" data-id="element-1023" data-mp="3w0ve5yx5hfpk" />
        </svg>
      </li>

      <li className={tile} title="Diners Club" data-id="element-1024" data-mp="ejc7siol5dcu">
        <svg viewBox="0 0 52 16" className="h-4 w-[46px]" role="img" aria-label="Diners Club" data-id="element-1025" data-mp="ej2jczj6ve99">
          <circle cx="8" cy="8" r="7" fill="#0079BE" data-id="element-1026" data-mp="9l0zwdhupcx9" />
          <circle cx="8" cy="8" r="4.2" fill="#FFFFFF" data-id="element-1027" data-mp="3i02mdly8gyq5" />
          <rect x="7.3" y="3.8" width="1.4" height="8.4" fill="#0079BE" data-id="element-1028" data-mp="3i0knowzr634x" />
          <text x="18" y="11.5" fill="#0079BE" fontFamily="Arial, Helvetica, sans-serif" fontSize="8" fontWeight="700" data-id="element-1029" data-mp="3d2j50d68o5tz">
            Diners
          </text>
        </svg>
      </li>

      <li className={tile} title="JCB" data-id="element-1030" data-mp="3mz5oaxix2otw">
        <svg viewBox="0 0 42 16" className="h-4 w-[38px]" role="img" aria-label="JCB" data-id="element-1031" data-mp="3my42by0d4hxe">
          <rect x="1" y="1" width="12" height="14" rx="3" fill="#0E4C96" data-id="element-1032" data-mp="1696z2kw07d45" />
          <rect x="15" y="1" width="12" height="14" rx="3" fill="#E21836" data-id="element-1033" data-mp="1284vxsyyugww" />
          <rect x="29" y="1" width="12" height="14" rx="3" fill="#007B40" data-id="element-1034" data-mp="19syzhapvjwja" />
          <text x="7" y="11.5" textAnchor="middle" fill="#FFF" fontFamily="Arial, Helvetica, sans-serif" fontSize="8" fontWeight="700" data-id="element-1035" data-mp="19v1z8mgtx417">J</text>
          <text x="21" y="11.5" textAnchor="middle" fill="#FFF" fontFamily="Arial, Helvetica, sans-serif" fontSize="8" fontWeight="700" data-id="element-1036" data-mp="zvb20d0vwaxf">C</text>
          <text x="35" y="11.5" textAnchor="middle" fill="#FFF" fontFamily="Arial, Helvetica, sans-serif" fontSize="8" fontWeight="700" data-id="element-1037" data-mp="14vp31b42ikly">B</text>
        </svg>
      </li>

      <li className={tile} title="PayPal" data-id="element-1038" data-mp="1xgyqmbr3loye">
        <svg viewBox="0 0 52 16" className="h-4 w-[46px]" role="img" aria-label="PayPal" data-id="element-1039" data-mp="1xk4fbpvteotl">
          <text x="0" y="12" fill="#253B80" fontFamily="Arial, Helvetica, sans-serif" fontSize="11" fontWeight="700" data-id="element-1040" data-mp="1iraxhxt2lwlr">
            Pay
          </text>
          <text x="23" y="12" fill="#179BD7" fontFamily="Arial, Helvetica, sans-serif" fontSize="11" fontWeight="700" data-id="element-1041" data-mp="2bh036ogq6ktp">
            Pal
          </text>
        </svg>
      </li>

      <li className={tile} title="Amazon Pay" data-id="element-1042" data-mp="sk6ds2kvkieo">
        <svg viewBox="0 0 52 20" className="h-5 w-[46px]" role="img" aria-label="Amazon Pay" data-id="element-1043" data-mp="sm127qvcusni">
          <text x="1" y="10" fill="#232F3E" fontFamily="Arial, Helvetica, sans-serif" fontSize="9" fontWeight="700" data-id="element-1044" data-mp="njs82r6qxkjt">
            amazon
          </text>
          <path d="M3 13.2c5 2.6 12.5 2.8 18.5.2" stroke="#FF9900" strokeWidth="1.4" fill="none" strokeLinecap="round" data-id="element-1045" data-mp="dnff5vj0zaq4" />
          <path d="M19.6 12.2l2.2 1-1 2.1" stroke="#FF9900" strokeWidth="1.2" fill="none" strokeLinecap="round" data-id="element-1046" data-mp="1bb7h12t13041" />
          <text x="34" y="10" fill="#232F3E" fontFamily="Arial, Helvetica, sans-serif" fontSize="9" fontWeight="400" data-id="element-1047" data-mp="16d5to5okkemr">
            pay
          </text>
        </svg>
      </li>

      <li className={tile} title="Apple Pay" data-id="element-1048" data-mp="wmtdepnsf7mf">
        <svg viewBox="0 0 52 16" className="h-4 w-[46px]" role="img" aria-label="Apple Pay" data-id="element-1049" data-mp="wlrs7sd254qz">
          <path d="M9.6 4.3c-.5.6-1.3 1-2 .9-.1-.8.3-1.6.7-2.1.5-.6 1.3-1 2-1 .1.8-.2 1.6-.7 2.2zm.7 1.1c-1.1-.1-2 .6-2.5.6-.5 0-1.3-.6-2.2-.6-1.1 0-2.2.7-2.7 1.7-1.2 2-.3 5 .9 6.6.6.8 1.2 1.7 2.1 1.6.9 0 1.2-.6 2.3-.6 1.1 0 1.3.6 2.2.6.9 0 1.5-.8 2.1-1.7.4-.6.6-1 .9-1.7-2.3-.9-2.6-4-.3-5.3-.4-.6-1-1.1-1.8-1.2z" fill="#000000" data-id="element-1050" data-mp="1u2qeyv873nz7" />
          <text x="17" y="13" fill="#000000" fontFamily="Arial, Helvetica, sans-serif" fontSize="10" fontWeight="600" data-id="element-1051" data-mp="26jrou6vewh42">
            Pay
          </text>
        </svg>
      </li>

      <li className={tile} title="Google Pay" data-id="element-1052" data-mp="2gigxd91f4p7n">
        <svg viewBox="0 0 56 16" className="h-4 w-[46px]" role="img" aria-label="Google Pay" data-id="element-1053" data-mp="2ghpe8xp0cjy9">
          <text x="0" y="12" fontFamily="Arial, Helvetica, sans-serif" fontSize="10" fontWeight="700" data-id="element-1054" data-mp="2ki9be19kznke">
            <tspan fill="#4285F4" data-id="element-1055" data-mp="2pb2fqo150tvy">G</tspan>
            <tspan fill="#EA4335" data-id="element-1056" data-mp="2u9cch32ig2jo">o</tspan>
            <tspan fill="#FBBC05" data-id="element-1057" data-mp="2u8apq1c4trm4">o</tspan>
            <tspan fill="#4285F4" data-id="element-1058" data-mp="2ubgh5n88h5l0">g</tspan>
            <tspan fill="#34A853" data-id="element-1059" data-mp="2z9ronrb23402">l</tspan>
            <tspan fill="#EA4335" data-id="element-1060" data-mp="2z6m0cea9465e">e</tspan>
          </text>
          <text x="38" y="12" fill="#5F6368" fontFamily="Arial, Helvetica, sans-serif" fontSize="10" fontWeight="600" data-id="element-1061" data-mp="348utpbr1da81">
            Pay
          </text>
        </svg>
      </li>

      <li className={tile} title="Shop Pay" data-id="element-1062" data-mp="29l31c5wzeflz">
        <svg viewBox="0 0 52 16" className="h-4 w-[46px]" role="img" aria-label="Shop Pay" data-id="element-1063" data-mp="29me545qffnd3">
          <rect width="52" height="16" rx="3" fill="#5A31F4" data-id="element-1064" data-mp="2ob0hbykrbz03" />
          <text x="26" y="11.5" textAnchor="middle" fill="#FFFFFF" fontFamily="Arial, Helvetica, sans-serif" fontSize="8" fontWeight="700" letterSpacing="0.3" data-id="element-1065" data-mp="2ji7h9o08heuc">
            shop Pay
          </text>
        </svg>
      </li>
    </ul>;
}